import { render, staticRenderFns } from "./ResetUserPasswordPopUp.vue?vue&type=template&id=5b5b98fa&scoped=true"
import script from "./ResetUserPasswordPopUp.vue?vue&type=script&lang=js"
export * from "./ResetUserPasswordPopUp.vue?vue&type=script&lang=js"
import style0 from "./ResetUserPasswordPopUp.vue?vue&type=style&index=0&id=5b5b98fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b98fa",
  null
  
)

export default component.exports